import { ServiceDrivenContent } from '@/api/interfaces/content/form/serviceDriven/serviceDrivenContent';
import { measuringPointOperatorsContent } from './measuringPointOperatorsContent';
import { generatorsContent } from './generatorsContent';
import { invertersContent } from './invertersContent';
import { installersContent } from './installersContent';

export const serviceDrivenContent: ServiceDrivenContent = {
    measuringPointOperatorsContent: measuringPointOperatorsContent,
    generatorsContent: generatorsContent,
    invertersContent: invertersContent,
    installersContent: installersContent,
};
